import PropTypes from "prop-types";

const TeambookRedButton = ({ text, onClick, style, size = "medium", className }) => {
  const buttonSizes = {
    small: { minHeight: "32px", minWidth: "75px", fontSize: "12px", padding: "4px 8px", borderRadius: "5px" },
    medium: { minHeight: "40px", fontSize: "14px", padding: "8px 14px" },
  };

  return (
    <button
      className={`teambook-red-button ${className || ""}`}
      onClick={onClick}
      style={{
        ...buttonSizes[size],
        ...style,
      }}
    >
      <p>{text}</p>
    </button>
  );
};

TeambookRedButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  style: PropTypes.object,
  size: PropTypes.oneOf(["small", "medium"]),
  className: PropTypes.string,
};

TeambookRedButton.defaultProps = {
  onClick: () => {},
  style: {},
  size: "medium",
  className: "",
};

export default TeambookRedButton;
